<div class="market-pairs">
  <div class="custom-heading px-2 d-flex">
    <h5 class="text-color-theme" > {{"history"|translate}}</h5>
    <button type="button" class="btn btn-sm btn-filter" [matMenuTriggerFor]="colMenu">
      <i class="icon ion-md-list"></i></button>
    <mat-menu #colMenu="matMenu" class="mat-menu-panelcolors">
      <div class="menuu">
        <div style="margin: 11px; text-align: start;">
          <strong>{{"aval-cols" | translate}}</strong>
        </div>
        <div cdkDropList (cdkDropListDropped)="drop($event)" style="margin: 4px">
          <div *ngFor="let col of columns" cdkDrag class="card column-dropdown-bg">
            <div class="card-body form-switch d-flex align-items-center justify-content-between" style="padding: 10px; height: 30px;vertical-align: -webkit-baseline-middle ">
              <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="toggle(col, $event)" [checked]="col.isChecked" class="white-dark-smoke" style="margin: 0px !important;">
                <label [attr.for]="col.name" class="white-dark-smoke" style=" margin: 0px !important;">
                  <mat-icon class="text-muted" style="font-size: 22px;vertical-align: middle ;cursor: grab;">
                    drag_indicator
                  </mat-icon>
                  <span style="font-family: 'Almarai';padding-inline-start: 4px;">{{col.name | translate}}</span>
                </label>
              </mat-checkbox>
            </div>
          </div>
        </div>
      </div>
    </mat-menu>
  </div>
  <div id="recent-trades" class="table-custom" style="overflow:scroll">
    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-sm table-dark">
      <thead>
        <tr>
          <th class="fit"></th>
          <th class="fit" *ngFor="let item of colsss">{{ item.name | translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of orderRequest">
          <td class="fit">
            <i (click)="viewOrder(item.OrderNumber)" class="fas fa-clock-rotate-left font-large color-antiq"></i>
          </td>
          <td *ngFor="let x of colsss" class="fit">
            <span class="fit" *ngIf="isSymbol(x.prop)">
              <span *ngIf="item.SymbolShortNameEn != null && item.SymbolShortNameAr != null">{{(translate.currentLang == 'en')?item.SymbolShortNameEn:item.SymbolShortNameAr}}</span>
              <span *ngIf="item.SymbolShortNameEn == null && item.SymbolShortNameAr == null">{{(translate.currentLang == 'en')?item.SymbolNameEn:item.SymbolNameAr}}</span>
            </span>
            <span class="fit" *ngIf="isLastDate(x.prop)">
              <span *ngIf="item.lastTradeTime != null">{{item.lastTradeTime | date: 'medium'}}</span>
              <span *ngIf="item.lastTradeTime == null">{{item.CreateDate | date: 'medium'}}</span>
            </span>
            <span class="fit" *ngIf="isPriceType(x.prop)">
              <span *ngIf="item.IsMarketPrice == false">{{"limit" | translate}}</span>
              <span class="green" *ngIf="item.IsMarketPrice == true">{{"market" | translate}}</span>
            </span>
            <span *ngIf="isDate(x.prop)">{{ item[x.prop]| date: 'medium' }}</span>
            <span *ngIf="isCustdCode(x.name)">{{item.CustodianCode}}</span>
            <span *ngIf="isStatus(x.prop)" class="badge" [ngStyle]="{'background-color': getBackgroundColor(item.FixStatus),'color':getColor(item.FixStatus)}">{{(translate.currentLang == 'en')?item?.FixStatusEn:item?.FixStatusAr}}</span>
            <span *ngIf="isCustdName(x.name)">{{(translate.currentLang == 'en')?item[x.prop]?.CustodianNameE:item[x.prop]?.CustodianNameA}}</span>
            <span *ngIf="isTransaction(x.prop)">{{(translate.currentLang == 'en')?item?.TransactionTypeEn:item?.TransactionTypeAr}}</span>
            <span *ngIf="isNum(x.prop)">{{ item[x.prop] | number: "1.2-2":"en-US"}}</span>
            <span *ngIf="!isDate(x.prop) && !isCustdCode(x.name) && !isCustdName(x.name) && !isNum(x.prop) && !isSymbol(x.prop) && !isLastDate(x.prop) && !isPriceType(x.prop) && !isTransaction(x.prop) && !isStatus(x.prop)">{{item[x.prop]}}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="no-data-available" *ngIf="!this.DataToShow">
      {{ "no-data-available" | translate }}
    </div>
  </div>
</div>
